(() => {
  // ---- SORTING ----
  const tableWrappers = document.querySelectorAll('.js-sortable-table');

  tableWrappers.forEach((tableWrapper, idx) => {
    const table = tableWrapper.querySelector('table');

    if (!table) {
      // eslint-disable-next-line no-param-reassign
      tableWrapper.style.display = 'none';
      return;
    }

    const sortButton = tableWrapper.querySelector('.js-sortable-table-button');
    const sortDropdown = tableWrapper.querySelector('.js-sortable-dropdown');
    const dropdownList = tableWrapper.querySelector('.js-sortable-dropdown-list');
    const ths = table.querySelectorAll('th');
    const tbody = table.querySelector('tbody');
    const rows = Array.from(tbody.querySelectorAll('tr')).filter((row) => row.querySelector('td'));
    let hideTimeout;
    let isDropdownVisible;
    const rowsPerPage = parseInt(tableWrapper.dataset.rows, 10) || 10;
    const paginationContainer = tableWrapper.querySelector('.sortable-table-pages');
    const numPages = Math.ceil(rows.length / rowsPerPage);

    table.setAttribute('aria-live', 'polite');

    const showDropdown = () => {
      clearTimeout(hideTimeout);
      if (!isDropdownVisible) {
        sortDropdown.classList.add('is-active');
        sortButton.setAttribute('aria-expanded', 'true');
        isDropdownVisible = true;

        // Move focus to the first radio button in the dropdown
        const firstRadioButton = sortDropdown.querySelector('input[type="radio"]');
        if (firstRadioButton) firstRadioButton.focus();
      }
    };

    const hideDropdown = () => {
      // Delay hiding the dropdown
      hideTimeout = setTimeout(() => {
        sortDropdown.classList.remove('is-active');
        sortButton.setAttribute('aria-expanded', 'false');
        isDropdownVisible = false;
      }, 100);
    };

    const toggleDropdown = () => {
      if (isDropdownVisible) {
        hideDropdown();
      } else {
        showDropdown();
      }
    };

    sortButton.addEventListener('mouseover', showDropdown);
    sortDropdown.addEventListener('mouseover', showDropdown);

    sortButton.addEventListener('mouseout', hideDropdown);
    sortDropdown.addEventListener('mouseout', hideDropdown);

    sortButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDropdown();
      }
    });

    sortButton.addEventListener('click', toggleDropdown);

    const updateTable = () => {
      const activeLink = tableWrapper.querySelector('.sortable-table-pages .active');
      const currentPage = activeLink ? parseInt(activeLink.textContent, 10) : 1;
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;

      while (tbody.firstChild) tbody.removeChild(tbody.firstChild);

      rows.forEach((row, i) => {
        // eslint-disable-next-line no-param-reassign
        row.style.display = (i >= startIndex && i < endIndex) ? '' : 'none';
        tbody.appendChild(row);
      });
    };

    const getCellValue = (value) => {
      if (value.startsWith('$')) return Number(value.replace(/\$/g, '').replace(/,/g, ''));
      const numValue = Number(value.replace(/,/g, ''));
      if (!Number.isNaN(numValue)) return numValue;
      return value;
    };

    const sortTable = (columnIndex, ascending) => {
      rows.sort((rowA, rowB) => {
        const cellA = rowA.querySelector(`td:nth-child(${columnIndex + 1})`);
        const cellB = rowB.querySelector(`td:nth-child(${columnIndex + 1})`);

        const valueA = getCellValue(cellA.textContent.trim());
        const valueB = getCellValue(cellB.textContent.trim());

        if (valueA === valueB) return 0;
        // eslint-disable-next-line no-nested-ternary
        return ascending ? (valueA < valueB ? -1 : 1) : (valueA > valueB ? -1 : 1);
      });

      updateTable();
    };

    dropdownList.addEventListener('change', (e) => {
      if (e.target.type === 'radio') {
        const cellIndex = parseInt(e.target.dataset.cellIndex, 10);
        const isAscending = e.target.dataset.isAscending === 'true';
        sortTable(cellIndex, isAscending);
      }
    });

    tableWrapper.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDropdownVisible) {
        e.preventDefault();
        hideDropdown();
        sortButton.focus();
      }
    });

    const createRadioInput = (text, type, cellIndex, isAscending) => {
      const radioInput = document.createElement('input');
      radioInput.type = 'radio';
      radioInput.name = `sortable-table-${idx}`;
      radioInput.id = `${text}-${type}-${idx}`;
      radioInput.value = type;
      radioInput.dataset.cellIndex = cellIndex;
      radioInput.dataset.isAscending = isAscending;

      return radioInput;
    };

    const createRadioLabel = (text, type) => {
      const radioLabel = document.createElement('label');
      radioLabel.setAttribute('for', `${text}-${type}-${idx}`);
      radioLabel.textContent = `${text} (${type})`;
      return radioLabel;
    };

    const createRadioAndAppend = (name, type, cellIndex, isAscending) => {
      const radioInput = createRadioInput(name, type, cellIndex, isAscending);
      const radioLabel = createRadioLabel(name, type);
      const radio = document.createElement('div');
      radio.classList.add('radio');

      radio.appendChild(radioInput);
      radio.appendChild(radioLabel);
      dropdownList.appendChild(radio);
    };

    ths.forEach((th) => {
      createRadioAndAppend(th.textContent, 'ascending', th.cellIndex, true);
      createRadioAndAppend(th.textContent, 'descending', th.cellIndex, false);
    });

    // ---- PAGINATION ----

    if (numPages === 1) return;

    rows.slice(rowsPerPage).forEach((row) => {
      // eslint-disable-next-line no-param-reassign
      row.style.display = 'none';
    });

    const createArrow = (direction, className) => {
      const arrowWrapper = document.createElement('li');
      const arrow = document.createElement('a');
      arrow.href = '#';
      arrow.classList.add('sortable-table-arrow', `sortable-table-arrow--${direction}`, className);
      arrow.dataset.direction = direction;
      arrow.setAttribute('aria-label', `${direction} arrow`);
      arrow.addEventListener('click', (e) => {
        e.preventDefault();
        const activeLink = tableWrapper.querySelector('.sortable-table-pages .active');
        const sibling = e.target.dataset.direction === 'previous' ? activeLink.parentNode.previousElementSibling : activeLink.parentNode.nextElementSibling;

        const siblingText = parseInt(sibling.textContent, 10);
        if (sibling && !Number.isNaN(siblingText)) {
          const siblingLink = sibling.querySelector('a');
          siblingLink.click();
        }
      });
      arrowWrapper.appendChild(arrow);
      return arrowWrapper;
    };

    const updateArrowState = (currentPage, totalPages) => {
      const previousArrow = tableWrapper.querySelector('.js-arrow-previous');
      const nextArrow = tableWrapper.querySelector('.js-arrow-next');

      if (currentPage === 1) {
        previousArrow.classList.add('disabled');
        previousArrow.tabIndex = -1;
      } else {
        previousArrow.classList.remove('disabled');
        previousArrow.removeAttribute('tabIndex');
      }

      if (currentPage === totalPages) {
        nextArrow.classList.add('disabled');
        nextArrow.tabIndex = -1;
      } else {
        nextArrow.classList.remove('disabled');
        nextArrow.removeAttribute('tabIndex');
      }
    };

    const createArrowAndAppend = (arrowText, arrowClass) => {
      const arrow = createArrow(arrowText, arrowClass);
      paginationContainer.appendChild(arrow);
    };

    const createPaginationLink = (index) => {
      const linkWrapper = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#';
      link.textContent = index;
      // eslint-disable-next-line no-use-before-define
      link.addEventListener('click', (e) => updateActiveLink(e));
      if (index === 1) {
        link.setAttribute('aria-current', 'page');
        link.setAttribute('aria-label', `page ${index}`);
      } else if (index === numPages) {
        link.setAttribute('aria-label', `last page, page ${index}`);
      } else {
        link.setAttribute('aria-label', `page ${index}`);
      }

      linkWrapper.appendChild(link);
      return linkWrapper;
    };

    const updatePageNumbers = (currentPage) => {
      let pageArray = [];

      // Always add current page number
      pageArray.push(currentPage);

      // Add previous two pages if current page number > 2
      if (currentPage > 2) {
        pageArray.push(currentPage - 2, currentPage - 1);
      } else if (currentPage === 2) {
        pageArray.push(currentPage - 1);
      }

      // Add next two pages if current page number < page count - 1
      if (currentPage < numPages - 1) {
        pageArray.push(currentPage + 1, currentPage + 2);
      } else if (currentPage === numPages - 1) {
        pageArray.push(currentPage + 1);
      }

      // Add first page and last page
      pageArray.push(1, numPages);

      // Remove duplicates and sort the pages
      pageArray = [...new Set(pageArray)].sort((a, b) => a - b);

      // Add ellipsis after first page and before last page if needed
      if (pageArray[1] > 2) {
        pageArray.splice(1, 0, '...');
      }
      if (pageArray[pageArray.length - 2] < numPages - 1) {
        pageArray.splice(pageArray.length - 1, 0, '...');
      }

      paginationContainer.innerHTML = '';

      createArrowAndAppend('previous', 'js-arrow-previous');

      pageArray.forEach((i) => {
        if (i === '...') {
          const ellipsis = document.createElement('li');
          ellipsis.textContent = i;
          paginationContainer.appendChild(ellipsis);
        } else {
          const link = createPaginationLink(i);
          paginationContainer.appendChild(link);
        }
      });

      createArrowAndAppend('next', 'js-arrow-next');

      const activeLink = Array.from(tableWrapper.querySelectorAll('.sortable-table-pages a')).find((a) => parseInt(a.textContent, 10) === currentPage);
      activeLink.classList.add('active');
      activeLink.setAttribute('aria-current', 'page');
    };

    const updateActiveLink = (e) => {
      e.preventDefault();
      const pageNum = parseInt(e.target.textContent, 10);
      const startIndex = (pageNum - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      rows.forEach((row, i) => {
        // eslint-disable-next-line no-param-reassign
        row.style.display = (i >= startIndex && i < endIndex) ? '' : 'none';
      });

      updatePageNumbers(pageNum);

      updateArrowState(pageNum, numPages);

      const firstVisibleRow = Array.from(tbody.querySelectorAll('tr')).filter((row) => row.style.display !== 'none')[0];
      firstVisibleRow.querySelector('td:first-child a').focus();
    };

    // initial state for page numbers
    updatePageNumbers(1);

    // initial state update for arrows
    updateArrowState(1, numPages);
  });
})();
